<section class="banner">
  <div #air id="air" class="air"></div>

  <app-nav class="w-100"></app-nav>
  <div class="pos-rel">
    <div class="px-4 py-5 md:px-6 lg:px-8 mx-height w-100">
      <!-- <ul *ngIf="showBreadCrums" style="flex-wrap: wrap"
                class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
                <li [hidden]="noHome" class="bredcrum-header" routerLink="/home" style="cursor: pointer">
                    <a style="color: white !important" class="no-underline line-height-3 cursor-pointer">{{ "Home page"
                        | translator }}</a>
                </li>
                <ng-container *ngFor="let item of breadcrumbs">
                    <li class="px-2">
                        <i class="pi pi-angle-left text-500 line-height-3"></i>
                    </li>
                    <li class="bredcrum-header" [routerLink]="item.link" [queryParams]="queryParams"
                        style="cursor: pointer">
                        <span class="line-height-3">{{ item.name }}</span>
                    </li>
                </ng-container>
            </ul> -->
      <div class="v4-flex w-100">
        <div>
          <div class="directory-v4">{{ header }}</div>
          <ul *ngIf="showBreadCrums" style="flex-wrap: wrap"
            class="list-none p-0 m-0 flex align-items-center font-medium my-2">
            <li [hidden]="noHome" routerLink="/home">
              <a class="directory-text">{{ "Home page" | translator }}</a>
            </li>
            <ng-container *ngFor="let item of breadcrumbs">
              <li class="px-2 mt-2">
                <i class="pi pi-angle-left directory-icone"></i>
              </li>
              <li [routerLink]="item.link" [queryParams]="item.queryParams ? item.queryParams : queryParams">
                <span class="directory-text-active">{{ item.name }}</span>
              </li>
            </ng-container>
          </ul>
          <div class="flex align-items-center text-700 flex-wrap">
            <div *ngFor="let item of stats" class="v4-color ml-5 flex align-items-center">
              <i class="{{ item.icon }} ml-2"></i>
              <span>{{ item.number }} {{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="mt-3 lg:mt-0 mobile-header-btn" dir="ltr">
          <div class="main-ms-outline header-flex">
            <ng-container *ngFor="let item of links">
              <button pButton pRipple [label]="item.name" class="p-button-outlined ml-2 my-1 btn-v4" iconPos="right"
                [icon]="item.icon" (click)="onBackClicked(item)"></button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="mt-3 lg:mt-0 mobile-header-btn" dir="ltr">
            <div class="main-ms-outline">
                <ng-container *ngFor="let item of links">
                    <button pButton pRipple [label]="item.name" class="p-button-outlined ml-2 my-1" iconPos="right"
                        [icon]="item.icon" [routerLink]="item.link"
                        [queryParams]="item.queryParams ? item.queryParams : queryParams"
                        (click)="onBackClicked()"
                        ></button>
                </ng-container>
            </div>

        </div> -->
  </div>
</section>